import React from "react";
import { injectIntl } from "react-intl";
import { getClassName } from "ui-kit/utils/component";

import "./Notification.scss";

const ccn = getClassName("Notification");

const getMessageId = (code) => {
  switch (code) {
    case 105:
      return "account.denied";
    case 210:
      return "created";
    case 220:
      return "modified";
    case 230:
      return "canceled";
    case 250:
      return "invest.processed";
    case 301:
      return "card.not.found";
    case 310:
      return "card.created";
    case 312:
      return "failed.create.card.currency.not.available";
    case 313:
      return "failed.create.card.status.pending";
    case 412:
      return "not.enough.funds";
    case 510:
      return "withdrawal.initiated";
    case 511:
      return "withdrawal.error";
    case 520:
      return "withdrawal.modified";
    case 530:
      return "withdrawal.canceled";
    default:
      return "making";
  }
};

const Notification = ({
  date,
  type,
  text,
  amount,
  currency,
  intl: { formatMessage }
}) => (
  <div className={ccn()}>
    <p className={ccn("date")}>{date}</p>
    <p className={ccn("text")}>
      {formatMessage(
        {
          id: `hbc.notification.${getMessageId(type)}`,
          defaultMessage: `${text}`
        },
        { dollars: `${amount} ${currency}` }
      )}
    </p>
  </div>
);

export default injectIntl(Notification);



// WEBPACK FOOTER //
// ./src/containers/notifications/notification/Notification.js